import { Skeleton } from '@mui/material';
import { makeStyles } from '@mui/styles';
import Grid from 'apollo-react/components/Grid';
import classNames from 'classnames';
import _ from 'lodash';
import qs from 'query-string';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';

import HyperLink from './ssHyperLink/HyperLinkComponent';
import { launchPreview } from '../../actions/ScormActions';
import { SCORM_CONTENT_TYPE_OPTIONS } from '../../constants/ScormEnums';
import { useFormSelector } from '../../custom-hooks';
import { useTranslation } from '../../custom-hooks/useTranslation';
import { getUITA } from '../../utils/commonUtils';
import { getEnvVar } from '../../utils/env';
import { PanelContext } from '../../utils/PanelConfig';
import { getDomainUrl } from '../../utils/qs';
import { getCourseNames } from '../selectors/runtime.selectors';

const DEFAULT_LABELS = ['Content (Initial)', 'Content (Refresher)', 'Content (Revision)'];

const useStyles = makeStyles({
  styledLabel: {
    height: 21,
    fontFamily: 'Proxima Nova',
    fontSize: 14,
    fontWeight: 400,
    fontStyle: 'normal',
    fontStretch: 'normal',
    lineHeight: 1.5,
    letterSpacing: 'normal',
    color: '#333',
    wordBreak: 'break-word',
  },
});

const SSScormFileReadOnly = ({
  label: propLabel,
  scormContentTypeOptions: contentTypeOption = 'INITIAL',
  isInHeader,
}) => {
  const translateString = useTranslation();
  const dispatch = useDispatch();
  const courseNames = useFormSelector(getCourseNames);

  const classes = useStyles();
  const layoutContext = useContext(PanelContext);

  const [loading, setLoading] = useState(false);
  const [previewLink, setPreviewLink] = useState(null);
  const initialized = useRef(false);

  const certificationType = SCORM_CONTENT_TYPE_OPTIONS[contentTypeOption];
  const courseName = courseNames[certificationType];
  const label = propLabel || DEFAULT_LABELS[certificationType];
  const appUrl = new URL(getEnvVar('REACT_APP_ADMIN_APP_URL'));
  const baseURL = appUrl.origin;

  useEffect(() => {
    const getLaunchPreview = async () => {
      const { itmId } = qs.parse(window.location.search);
      const domainUrl = getDomainUrl();

      setLoading(true);

      if (_.isNil(itmId) || _.isNil(certificationType)) {
        return;
      }

      try {
        const data = await dispatch(
          launchPreview({
            courseId: `CourseId|${itmId}!CertificationType|${certificationType}`,
            RedirectOnExitUrl: `${domainUrl}/close`,
          })
        );

        if (data.PreviewLink) {
          setPreviewLink(data.PreviewLink);
        }
      } catch {
        setPreviewLink(null);
      } finally {
        setLoading(false);
      }
    };

    if (!initialized.current) {
      getLaunchPreview();
      initialized.current = true;
    }
  }, [certificationType, dispatch]);

  const labelProps =
    layoutContext.layout === 'md'
      ? {
          className: (classes.fixedLabelContainer, !isInHeader ? classes.styledLabelDetail : ''),
        }
      : { xs: 4 };

  return (
    <Grid container spacing={1} ui-ta={getUITA('FormCtrl', 'SSScormFileInput')}>
      <Grid item {...labelProps}>
        <span className={classNames(classes.styledLabel)}>{translateString(label.trim())}</span>
      </Grid>
      <Grid item>
        {loading && <Skeleton variant="text" width={120} />}
        {!loading && previewLink && (
          <HyperLink
            pathname={`${baseURL}${previewLink}`}
            text={courseName || ''}
            hasIcon={false}
            target="_blank"
          />
        )}
      </Grid>
    </Grid>
  );
};

export default SSScormFileReadOnly;
